<div class="modalShareProfile">
  <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline" [class.hidden]="sharing"></ion-icon>
  </div>
  <div class="modalShareProfileContent">
      <div class="title">{{'shareYourProfile' | translate}}
      </div>
      <span class="description" [innerHTML]="'shareYourProfileDescription' | translate"></span>
      <ion-button expand="block" class="button-edit-profile-share" shape="round" (click)="triggerShare()" [disabled]="sharing">
          <ng-container *ngIf="!sharing">
              <ion-icon name="share-social" class="button-edit-profile-share-icon"></ion-icon>
              {{'share' | translate}}
          </ng-container>
          <ng-container *ngIf="sharing">
              <ion-spinner name="crescent" class="button-edit-profile-share-spinner"></ion-spinner>
              &nbsp;{{ 'generating' | translate }}
          </ng-container>
      </ion-button>
  </div>
</div>
